/**
 * @generated SignedSource<<05d60511564bdb45bbc9a89938dfe782>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingBriefsCreateMeetingBriefMutation$variables = {
  noteId: string;
};
export type MeetingBriefsCreateMeetingBriefMutation$data = {
  readonly createMeetingBrief: {
    readonly note: {
      readonly id: string;
      readonly meetingBrief: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type MeetingBriefsCreateMeetingBriefMutation = {
  response: MeetingBriefsCreateMeetingBriefMutation$data;
  variables: MeetingBriefsCreateMeetingBriefMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "CreateMeetingBrief",
    "kind": "LinkedField",
    "name": "createMeetingBrief",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingBrief",
            "kind": "LinkedField",
            "name": "meetingBrief",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingBriefsCreateMeetingBriefMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingBriefsCreateMeetingBriefMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "86395860d78d0dcd7505fca376c99456",
    "id": null,
    "metadata": {},
    "name": "MeetingBriefsCreateMeetingBriefMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingBriefsCreateMeetingBriefMutation(\n  $noteId: ID!\n) {\n  createMeetingBrief(noteId: $noteId) {\n    note {\n      id\n      meetingBrief {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0059c27008f2e4f771ffc02270285e1";

export default node;
